/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
// import ReactDOMServer from "react-dom/server";
import { useReactToPrint } from "react-to-print";
import "./MyPrint.css";
import logo from "../../../assets/images/Logo-AI.png";

import POService from "../../../service/PurchaseOrder.service";
import {
  Button,
  Card,
  Flex,
  Table,
  Typography,
  message,
  Space,
  Spin,
  Row,
  Col,
} from "antd";
import { column } from "./model";

import dayjs from "dayjs";
// import { comma } from '../../../utils/util';
import { PiPrinterFill } from "react-icons/pi";
import { LoadingOutlined } from "@ant-design/icons";

const recservice = POService();

function POPrintPreview() {
  const { code } = useParams();
  const componentRef = useRef(null);
  const printRef = useRef(null);

  const handlePrint = useReactToPrint({
    documentTitle: "Print This Document",
    onBeforePrint: () => handleBeforePrint(),
    onAfterPrint: () => handleAfterPrint(),
    removeAfterPrint: true,
  });

  const [hData, setHData] = useState({});
  const [details, setDetails] = useState([]);

  const [newPageContent, setNewPageContent] = useState([]);
  const columnDesc = column;

  const [loading, setLoading] = useState(false);

  const handleAfterPrint = () => {
    setNewPageContent([]);
  };
  const handleBeforePrint = (e) => {
    console.log("before printing...");
  };

  const handleCheckMultiPages = async () => {
    const limitPage = 520;
    return new Promise((r) => {
      // const head = document.querySelector("#raw .in-head");
      const data = document.querySelector("#raw .in-data");
      const table = document.querySelector("#raw .in-data #tb-data");
      // const thead = table?.querySelector("thead");
      const mtbody = table?.querySelector("tbody");
      // const mtfoot = table?.querySelector("tfoot");
      const row = mtbody?.querySelectorAll("tr");

      const samplesPage = [];
      // console.log(mtfoot);
      // console.log(componentRef.current);
      // let pageCount = 1;
      let hPageCheck = 0;
      let emlContent = [];
      for (let elm of row) {
        const h = Number(
          window
            .getComputedStyle(elm)
            .getPropertyValue("height")
            ?.replace("px", "")
        );
        if (hPageCheck + h > limitPage) {
          // console.log( { hPageCheck } );
          samplesPage.push([...emlContent, elm]);
          emlContent = [];
          hPageCheck = 0;
        } else {
          hPageCheck += h;
          emlContent = [...emlContent, elm];
        }

        // console.log( h, hPageCheck );
      }
      if (emlContent.length > 0) samplesPage.push(emlContent);

      // const hfoot = Number(window.getComputedStyle(mtfoot).getPropertyValue('height')?.replace("px", ""));
      const pages = [];
      for (let rind in samplesPage) {
        // const chead = head.cloneNode(true);
        const cdata = data.cloneNode(true);
        const table = cdata.querySelector("#tb-data");
        // const thead = table?.querySelector("thead");
        const tbody = table?.querySelector("tbody");
        const tfoot = table?.querySelector("tfoot");

        // tbody.style.height = `${limitPage - hfoot}px`;

        tbody.innerHTML = `${samplesPage[rind]
          .map((m) => m.outerHTML)
          .join("")}`;

        if (rind < samplesPage.length - 1) tfoot.remove();
        // else {
        //     tbody.innerHTML = `${tbody.innerHTML}<tr><td colspan='6' style="height:100%">&nbsp;</td></tr>`;
        // }
        const temp = document.createElement("div");

        // temp.appendChild( chead );
        temp.appendChild(cdata);
        temp.classList.add("on-page");
        pages.push(temp);
      }
      // console.log( pages );
      setNewPageContent((state) => [...state, ...pages]);
      r(pages);
    });
  };
  const handlePrintMultiPages = () => {
    setLoading(true);
    handleCheckMultiPages().then((res) => {
      handlePrint(null, () => printRef.current);
      setLoading(false);
    });
  };

  useEffect(() => {
    const init = () => {
      recservice
        .get(code)
        .then(async (res) => {
          const { header, detail } = res.data;

          setHData(header);
          setDetails(detail);
        })
        .catch((err) => {
          console.log(err);
          message.error("Error getting Quotation.");
        });
    };

    init();
    return () => {};
  }, []);

  const HeaderForm = ({ ...resProps }) => {
    return (
      <>
        <div className="print-head" style={{ height: 90 }}>
          <div className="print-title">
            <ContentHead {...resProps} />
          </div>
        </div>
        <ContentHead2 {...resProps} />
      </>
    );
  };

  const FooterForm = ({ page }) => {
    return (
      <div className="print-foot" style={{ height: 34 }}>
        <div className="print-title flex justify-end">
          <Flex className="mb-0">
            <Typography.Text className="text-sm min-w-8">Page</Typography.Text>
            <Typography.Text className="text-sm" strong>
              {page}
            </Typography.Text>
          </Flex>
        </div>
      </div>
    );
  };

  const ContentHead = () => {
    return (
      <div className="content-head in-sample flex flex-col">
        <div className="print-title">
          <Row>
            <Col span={6}>
              <Flex className="mb-1.5" vertical>
                <div className="grow pb-2">
                  <img
                    src={logo}
                    alt=""
                    style={{
                      width: "100%",
                      float: "left",
                      marginLeft: "-15px",
                      position: "absolute",
                    }}
                  />
                </div>
              </Flex>
            </Col>
            <Col span={12}>
              <Flex className="mb-0" vertical>
                <Typography.Text
                  className="tx-title min-w-48 weight600"
                  style={{ fontSize: 40, textAlign: "center" }}
                  strong
                >
                  A.I. Solution Service Co., Ltd.
                </Typography.Text>
                <Typography.Text style={{ fontSize: 20, textAlign: "center" }}>
                  29/2 Moo 3,Sala Khru,Nong Suea,Pathum Thani 12170
                </Typography.Text>
              </Flex>
            </Col>

            <Col span={6}>
              <table className="w-full border-collapse border outline outline-1 outline-black-400 overflow-hidden text-center rounded-xl">
                <tr>
                  <td className="border outline outline-1 outline-gray-400">
                    <Typography.Text
                      style={{ fontSize: 25, margin: 0, padding: 0 }}
                    >
                      ใบสั่งซื้อสินค้า
                    </Typography.Text>
                    <br></br>
                    <Typography.Text
                      style={{
                        fontSize: 20,
                        display: "block",
                        marginTop: "-20px",
                      }}
                    >
                      Purchase Order
                    </Typography.Text>
                  </td>
                </tr>
                <tr>
                  <td className="border outline outline-1 outline-black-400 text-start">
                    <Space className="w-full items-baseline ml-2">
                      <Typography.Text
                        strong
                        style={{ display: "block", width: 70, fontSize: 16 }}
                      >
                        เลขที่/No :
                      </Typography.Text>
                      <Typography.Text
                        className="text-start"
                        style={{ display: "block", fontSize: 18 }}
                      >
                        {hData.pocode}
                      </Typography.Text>
                    </Space>
                    <Space className="w-full items-baseline ml-2">
                      <Typography.Text
                        strong
                        style={{ display: "block", width: 70, fontSize: 16 }}
                      >
                        วันที่/Date :
                      </Typography.Text>
                      <Typography.Text
                        className="text-start"
                        style={{ display: "block", fontSize: 18 }}
                      >
                        {dayjs(hData?.redate).format("DD/MM/YYYY")}
                      </Typography.Text>
                    </Space>
                  </td>
                </tr>
              </table>
            </Col>
          </Row>
        </div>
        <Typography.Text
          strong
          style={{ display: "block", width: "100%", fontSize: 16 }}
        >
          Line ID : @golf_ai. &nbsp;&nbsp;&nbsp;Tel.
          080-2660934&nbsp;&nbsp;&nbsp;E-maill A.I.SolutionService15@gmail.com
          &nbsp;&nbsp;&nbsp;Website: www.aisolutionservice.com
        </Typography.Text>
      </div>
    );
  };
  const ReceiptSummary = () => {
    return (
      <>
        <Table.Summary.Row>
          <Table.Summary.Cell colSpan={8} className="!align-top !ps-0 !pt-3">
            <Flex>
              <Flex
                vertical
                className="w-1/3"
                style={{ gap: 10, marginLeft: 25 }}
              >
                <Flex gap={2} justify="center" style={{ paddingTop: 65 }}>
                  <Typography.Text className="tx-info text-center" strong>
                    <span>
                      {" "}
                      .............................................................................
                      <br></br>
                      Cofirmed by The Buyer
                    </span>
                  </Typography.Text>
                </Flex>
                <Flex gap={2} justify="center" style={{ paddingTop: 30 }}>
                  <Typography.Text className="tx-info text-center" strong>
                    <span>
                      Date&nbsp; &nbsp; &nbsp; &nbsp;
                      ............................................................
                    </span>
                  </Typography.Text>
                </Flex>
              </Flex>

              <Flex
                vertical
                className="w-1/3"
                style={{ gap: 10, marginLeft: 200 }}
              >
                <Flex gap={2} justify="center">
                  <Typography.Text className="tx-info text-center" strong>
                    For A.I. Solution Service Co.,Ltd.
                  </Typography.Text>
                </Flex>
                <Flex gap={2} justify="center" style={{ paddingTop: 25 }}>
                  <Typography.Text className="tx-info text-center" strong>
                    <span style={{ fontSize: 25 }}>
                      ---------------------------------------
                    </span>
                    <span>
                      <br></br>
                      Cofirmed by The Seller
                    </span>
                  </Typography.Text>
                </Flex>
                <Flex gap={2} justify="center" style={{ paddingTop: 22 }}>
                  <Typography.Text className="tx-info text-center" strong>
                    <span>
                      Date&nbsp; &nbsp; &nbsp;
                      &nbsp;...................................................................
                    </span>
                  </Typography.Text>
                </Flex>
              </Flex>
            </Flex>
          </Table.Summary.Cell>
        </Table.Summary.Row>
      </>
    );
  };
  const ContentHead2 = () => {
    return (
      <div className="head-data" style={{ paddingTop: "60px" }}>
        <Row style={{ border: "1px solid", borderRadius: 20 }}>
          <Col
            style={{
              paddingInline: 50,
              borderBottomLeftRadius: 20,
              padding: 20,
            }}
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
          >
            <div className="flex flex-col">
              <Space>
                <Typography.Text
                  strong
                  style={{ width: 128, fontSize: 14, paddingLeft: 10 }}
                  width={124}
                >
                  Vendor :
                </Typography.Text>
                <Typography.Text
                  strong
                  style={{
                    display: "block",
                    width: "100%",
                    fontSize: 14,
                    paddingLeft: 5,
                  }}
                >
                  {hData?.prename} {hData?.supname}
                </Typography.Text>
              </Space>
              <Space className="w-full items-baseline">
                <Typography.Text
                  strong
                  style={{ width: 128, fontSize: 14, paddingLeft: 10 }}
                  width={124}
                >
                  Address :
                </Typography.Text>
                <Space className="w-full items-baseline">
                  <Typography.Text
                    strong
                    style={{
                      display: "block",
                      width: "100%",
                      fontSize: 14,
                      paddingLeft: 5,
                    }}
                  >
                    {hData?.address}
                  </Typography.Text>
                </Space>
              </Space>
            </div>
          </Col>
        </Row>
      </div>
    );
  };

  const ContentBody = () => {
    return (
      <div
        className="content-body in-data flex flex-col"
        style={{ paddingTop: 10 }}
      >
        <Card size="small" bordered>
          <Table
            id="tb-data"
            size="small"
            dataSource={details}
            columns={columnDesc}
            pagination={false}
            rowKey="stcode"
            bordered={false}
            locale={{
              emptyText: <span>No data available, please add some data.</span>,
            }}
            onRow={(record, index) => {
              return { className: "r-sub" };
            }}
            summary={ReceiptSummary}
          />
        </Card>
      </div>
    );
  };

  const Pages = () => (
    <div ref={componentRef} id="raw">
      <ContentData>
        <ContentBody />
      </ContentData>
    </div>
  );

  const ContentData = ({ children, pageNum = 0, total = 0 }) => {
    return (
      <div className="rec-pages flex flex-col">
        <HeaderForm page={`${pageNum}/${total}`} />
        <div className="print-content grow">{children}</div>
        <FooterForm page={`${pageNum} of ${total}`} />
      </div>
    );
  };

  return (
    <>
      {/* <Spin spinning={loading} indicator={<LoadingOutlined style={{ fontSize: 24, }} spin />} fullscreen /> */}
      <div className="page-show" id="rec">
        {loading && <Spin fullscreen indicator={<LoadingOutlined />} />}
        <div className="title-preview">
          <Button
            className="bn-center  bg-blue-400"
            onClick={() => {
              handlePrintMultiPages();
            }}
            icon={<PiPrinterFill style={{ fontSize: "1.1rem" }} />}
          >
            PRINT
          </Button>
        </div>
        <div className="layout-preview">
          <Pages />
        </div>
        <div className="hidden" id="mypage">
          <div ref={printRef}>
            {newPageContent?.map((page, i) => {
              // console.log( page.innerHTML );
              return (
                <div key={i} className="on-page">
                  <ContentData pageNum={i + 1} total={newPageContent?.length}>
                    <div
                      dangerouslySetInnerHTML={{ __html: page.innerHTML }}
                    ></div>
                  </ContentData>
                  {i < newPageContent.length - 1 && (
                    <div className="page-break"></div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
}

export default POPrintPreview;
